import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=14a6e25b"
import script from "./Banners.vue?vue&type=script&lang=ts"
export * from "./Banners.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports